import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlan"><Path d="M14.5 6.5H8.21513C6.35178 6.5 5.77909 9.02478 7.46008 9.82873L16.5399 14.1713C18.2209 14.9752 17.6482 17.5 15.7849 17.5H9.5" stroke="currentColor"/><Path d="M14.5 9.5V3.5H20.5V9.5H14.5Z" stroke="currentColor"/><Path d="M3.5 20.5V14.5H9.5V20.5H3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPlan;
